import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import PageHeader from '../../components/page-header';
import SectionInfo from '../../views/site/siteinfo';
import SectionMail from '../../views/site/sitemail';
import SectionMeta from '../../views/site/sitemeta';


const Site = () => {
    const [site, setSite] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await apiService.get('/sites');
                const payload = response.data;
                setSite(payload.data);
            } catch (error) {
                console.error('Error fetching site data:', error);
            }
        }

        fetchData();
    }, [])

    return (
        <Page title="Site">
            <Box>
                <PageHeader
                    title={
                        <Typography variant='h5' color='#666CFF'>
                            사이트관리
                        </Typography>
                    }
                />

                <Grid container spacing={6} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                        <SectionInfo site={site} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SectionMail site={site} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <SectionMeta />
                    </Grid>
                </Grid>
            </Box>
        </Page>
    )
}

export default Site
